import { lazy } from 'react';
export const StudentExamList = lazy(() => import('./StudentExamList'));
export const StudentExamInstructions = lazy(() => import('./StudentExamInstructions'));
export const StudentExamStart = lazy(() => import('./StudentExamStart'));
export const StudentExamDetails = lazy(() => import('./StudentExamDetails'));
